import type { ToolsError } from "../../model/types";
import { useCanReload } from "./useCanReload";

export type ReloadOffer = "primary" | "secondary" | null;

export const isNoAccessError = (error: ToolsError | undefined): boolean => error?.code === "no-access";

/** Without access to the repository a retry rarely helps, so Reload is only a secondary action. */
export const useReloadOffer = (failure: ToolsError | undefined): ReloadOffer => {
	const canReload = useCanReload();
	if (!canReload) return null;
	return isNoAccessError(failure) ? "secondary" : "primary";
};
